import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './Header.module.css';

export const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <NavLink to="/">Enzo's Toolkit</NavLink>
      </div>
      <nav className={styles.nav}>
        <NavLink to="/" className={({ isActive }) => isActive ? styles.active : ''}>홈</NavLink>
        <NavLink to="/blog" className={({ isActive }) => isActive ? styles.active : ''}>블로그</NavLink>
        {/* <NavLink to="/tools" className={({ isActive }) => isActive ? styles.active : ''}>도구</NavLink> */}
      </nav>
    </header>
  );
};
